module.exports = __webpack_public_path__ + "static/offer-5-ed535adc7702eb83385239fe9823e21e.png";